module.exports = __webpack_public_path__ + "static/02-cc8e266a8fe6ec9946ac2004e9f1465f.jpg";